import useKeyPress from './useKeyPress';

export default useKeyPress;